module.exports = __webpack_public_path__ + "img/img-3-6mobile.bf1a1668.webp";